let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bJOZI")).then(() => parcelRequire('gsMPz'));